import { useLayoutEffect, useRef, type PropsWithChildren } from "react"

import { PAGE_TRANSITION_TUNING } from "@be-miniapp/ui/utils/page-transition"

/**
 * Softens the swap from Suspense fallback to lazy route content during enter.
 */
function RouteEnterContent({ children }: PropsWithChildren) {
  const ref = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return

    element.style.transition = "none"
    element.style.opacity = String(PAGE_TRANSITION_TUNING.pushEnterOpacity)

    const frame = requestAnimationFrame(() => {
      element.style.transition = `opacity 0.22s ${PAGE_TRANSITION_TUNING.easing}`
      element.style.opacity = "1"
    })

    const timeout = window.setTimeout(() => {
      element.style.transition = ""
      element.style.opacity = ""
    }, 280)

    return () => {
      cancelAnimationFrame(frame)
      window.clearTimeout(timeout)
    }
  }, [])

  return (
    <div ref={ref} className="h-full w-full">
      {children}
    </div>
  )
}

export { RouteEnterContent }
